module.exports = __webpack_public_path__ + "img/rec-02.4bd06b77.png";